import React, { useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import useNavigation from '@hooks/useNavigation';
import BreadCrumbComponent from '@components/obsolete/BreadCrumbComponent/BreadCrumbComponent.tsx';
import { CalendarLayoutModelDetailOutDTO } from '@api/ringil-api.v2';
import { CalendarLayoutModelEditor } from '@components/features/calendar-layout/management/CalendarLayoutModelEditor';

interface ComponentProps {
  modelId: string;
}

/**
 * One calendar layout model, as its own page.
 *
 * The breadcrumb is the way back — there is deliberately no back button, the same as every other
 * detail page in the app.
 */
const CalendarLayoutModelDetail: React.FC<ComponentProps> = ({ modelId }) => {
  const { tr } = useTranslationLgs();
  const navigation = useNavigation();
  const isMobile = useMediaQuery({ maxWidth: 1024 });

  // The model's name is only known once it loads, and both the breadcrumb and the heading need it.
  const [detail, setDetail] = useState<CalendarLayoutModelDetailOutDTO | null>(null);

  return (
    <>
      {!isMobile && (
        <BreadCrumbComponent
          items={[
            {
              label: tr('CalendarLayout.breadCrumb', 'Calendar card layouts'),
              url: navigation.createNavigationLink(navigation.urlFunctions.calendarLayoutUrlInfo()),
            },
            { label: detail?.name ?? '' },
          ]}
        />
      )}
      <CalendarLayoutModelEditor
        modelId={modelId}
        admin={false}
        onLoaded={setDetail}
        onDeleted={() => navigation.navigate(navigation.urlFunctions.calendarLayoutUrlInfo())}
        onOpenModel={newModelId => navigation.navigate(navigation.urlFunctions.calendarLayoutModel(newModelId))}
      />
    </>
  );
};

export default CalendarLayoutModelDetail;
